import { render } from "./Testimoni.vue?vue&type=template&id=5dfa1b66"
import script from "./Testimoni.vue?vue&type=script&lang=js"
export * from "./Testimoni.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__